import { Box } from '@mui/material';
import { DataCellProps } from '../types';

export const DataDeletionReasonCell = ({ team }: DataCellProps) => {
  return <Box>{team.reasonToArchive}</Box>;
};
